import { i18n } from '@lingui/core';
import { getStatusName } from '../../../utilities/StatusUtilities';

export default function getStatusFilterStateServiceFactory(title, paramName) {
    return (filterId) => {
        const StatusFilterStateService = {
            /*
             * Factory functions
             */
            createWithEncodedState(encodedState) {
                return StatusFilterStateService.decode(encodedState);
            },

            createWithDefaultState() {
                return [];
            },

            createState(encodedFilterState, dataService) {
                const encodedState = encodedFilterState?.[filterId];
                return encodedState
                    ? this.createWithEncodedState(encodedState, dataService)
                    : this.createWithDefaultState(dataService);
            },

            /*
             * Transformation functions
             */
            parameterize(state) {
                return {
                    [paramName]: state.join(','),
                };
            },

            encode(state) {
                return state?.join(',') || '';
            },

            decode(encodedState) {
                return (encodedState || '').split(',');
            },

            summarize(state) {
                const summary = state.map(getStatusName).join(', ');
                return {
                    title: i18n._(title),
                    value: summary,
                    shortValue: summary,
                };
            },
        };

        return StatusFilterStateService;
    };
}
